<template>
  <div class="pay-panel">
    <div class="content">
      <div class="content-top-bg" :style="'background:' + typeColor[payType] + ';'"></div>
      <div class="content-body">
        <header class="header">
          <div class="header-text">付款给 {{ merchantName }}</div>
          <div class="header-img">
            <img :src="avatar ? avatar : icon_member_default" alt="" />
          </div>
        </header>
        <div class="plus-input">
          <div class="S">
            <span :style="'color:' + typeColor[payType] + ';'">￥</span>
          </div>
          <div class="input-c" :style="'color:' + typeColor[payType] + ';'">
            <div class="input-c-div-1">{{ formatMoney(amount) }}</div>
            <div class="input-c-div" :style="'background:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"></div>
          </div>
          <div v-show="!amount" class="placeholder">请输入金额</div>
        </div>
      </div>
    </div>
    <ul class="plus-ul" >
      <li style="border-radius:10px;">
        <div class="img-div">
          <img :src="payImg" alt="" />
          <div class="div-text">
            支付宝支付
          </div>
        </div>
      </li>
    </ul>
    <div class="remark-k" :class="payType != 'wx' ? 'margin-top-30' : ''">
      <div class="remark">
        <div class="remark-hui" v-show="remark">{{ remark }}</div>
        <div @click="myDialogStateFn(remark)" :style="'color:' + typeColor[payType] + ';'">{{ remark ? "修改" : "添加备注" }}</div>
      </div>
    </div>
    <MyDialog
        v-show="myDialogState"
        @myDialogStateFn="myDialogStateFn"
        :remark="remark"
        :typeColor="typeColor[payType]"
    >
    </MyDialog>

    <div class="record-section">
      <template v-if="invoiceEnabled">
        <div class="record-menu-item" @click="showInvoiceList = !showInvoiceList">
          <span class="record-menu-text">我的发票</span>
          <span class="record-menu-toggle" :style="'color:' + typeColor[payType] + ';'">{{ showInvoiceList ? '收起' : '查看' }} ›</span>
        </div>
        <div v-if="showInvoiceList" class="record-list">
          <div v-if="invoiceList.length === 0" class="record-empty">暂无发票记录</div>
          <div v-for="(item, index) in invoiceList" :key="'inv-'+index" class="record-list-item">
            <div class="record-list-item-left">
              <div class="record-list-item-title">{{ item.titleName }}</div>
              <div class="record-list-item-desc">{{ item.createTime }}</div>
            </div>
            <div class="record-list-item-right">
              <div class="record-list-item-amount">￥{{ item.amount }}</div>
              <div class="record-list-item-status" :style="'color:' + typeColor[payType] + ';'">{{ item.statusText }}</div>
            </div>
          </div>
        </div>
        <div class="record-menu-divider"></div>
      </template>
      <div class="record-menu-item" @click="showTransactionList = !showTransactionList">
        <span class="record-menu-text">我的交易</span>
        <span class="record-menu-toggle" :style="'color:' + typeColor[payType] + ';'">{{ showTransactionList ? '收起' : '查看' }} ›</span>
      </div>
      <div v-if="showTransactionList" class="record-list">
        <div v-if="transactionList.length === 0" class="record-empty">暂无交易记录</div>
        <div v-for="(item, index) in transactionList" :key="'txn-'+index" class="record-list-item">
          <div class="record-list-item-left">
            <div class="record-list-item-title">{{ item.subject || '—' }}</div>
            <div class="record-list-item-desc">{{ formatTxnTime(item) }}</div>
          </div>
          <div class="record-list-item-right">
            <div class="record-list-item-amount">￥{{ formatTxnYuan(item.amount) }}</div>
            <div class="record-list-item-status" :style="'color:' + typeColor[payType] + ';'">{{ item.statusText }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="keyboard-plus" v-if="isAllowModifyAmount">
      <Keyboard
          @delTheAmount="delTheAmount"
          @conceal="conceal"
          @enterTheAmount="enterTheAmount"
          @clearTheAmount="clearTheAmount"
          @payment="payment"
          @paymentAndInvoice="paymentAndInvoice"
          :money="money"
          :concealSate="concealSate"
          :typeColor="typeColor[payType]"
          :touchTypeColor="touchTypeColor[payType]"
          :invoiceEnabled="invoiceEnabled"
      ></Keyboard>
    </div>
    <div class="bnt-pay" v-if="!isAllowModifyAmount">
      <div class="bnt-pay-group">
        <div
            class="bnt-pay-text"
            :style="'background:' + typeColor[payType] + ';'"
            @click="pay"
        >
          付款
        </div>
        <div
            v-if="invoiceEnabled"
            class="bnt-pay-text-outline"
            :style="'color:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"
            @click="payAndInvoice"
        >
          付款+开票
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPayPackage, getPayOrderInfo, getMyTransactions } from '@/api/api'
import config from "@/config";
import MyDialog from "@/views/dialog/dialog";
import Keyboard from "@/views/keyboard/keyboard";
export default {
  components: { MyDialog, Keyboard },
  data: function (){
    return {
      merchantName: '乘鱼掌柜',
      avatar: require("../../assets/images/zfb.jpeg"),
      amount: "",
      resData : {},
      payImg: require("../../assets/images/zfb.jpeg"),
      payOrderInfo: {},
      isAllowModifyAmount: true,
      myDialogState: false,
      remark: "",
      money: -1,
      concealSate: true,
      payType: "alipay",
      invoiceEnabled: false,
      fromInvoice: false,
      invoiceList: [],
      transactionList: [],
      showInvoiceList: false,
      showTransactionList: false,
      typeColor: {
        alipay: "#1678ff",
        wxpay: "#07c160",
        ysfpay: "#ff534d"
      },
      touchTypeColor: {
        alipay: "rgba(20, 98, 206, 1)",
        wxpay: "rgba(7, 130, 65, 1)",
        ysfpay: "rgb(248 70 65, 1)"
      },
    }
  },
  mounted() {
    this.fromInvoice = this.$route.query.fromInvoice === '1';
    this.loadInvoiceRecords();
    this.fetchMyTransactions();
    this.setPayOrderInfo();
  },
  methods: {
    loadInvoiceRecords() {
      this.invoiceList = JSON.parse(sessionStorage.getItem('invoiceRecords') || '[]');
      if (this.invoiceList.length > 0) this.showInvoiceList = true;
    },
    fetchMyTransactions() {
      const that = this;
      getMyTransactions(50).then(list => {
        that.transactionList = Array.isArray(list) ? list : [];
        if (that.transactionList.length > 0) that.showTransactionList = true;
      }).catch(() => {
        that.transactionList = [];
      });
    },
    formatTxnYuan(amountFen) {
      if (amountFen == null || amountFen === '') return '0.00';
      const n = Number(amountFen);
      if (isNaN(n)) return String(amountFen);
      return (n / 100).toFixed(2);
    },
    formatTxnTime(item) {
      const raw = item.successTime || item.createdAt || item.createTime;
      if (!raw) return '';
      const d = new Date(raw);
      if (isNaN(d.getTime())) return String(raw);
      return d.getFullYear() + '-' +
          String(d.getMonth() + 1).padStart(2, '0') + '-' +
          String(d.getDate()).padStart(2, '0') + ' ' +
          String(d.getHours()).padStart(2, '0') + ':' +
          String(d.getMinutes()).padStart(2, '0');
    },
    payment() {
      if (this.money == -1)
        return;
      this.pay();
    },
    paymentAndInvoice() {
      if (this.money == -1)
        return;
      this.goInvoicePage();
    },
    conceal() {
      this.concealSate = !this.concealSate
    },
    enterTheAmount(item) {
      if (this.amount >= 9999999
          || (item === "." && this.amount.includes("."))
          || (this.amount.includes(".") && this.amount.split(".").pop().length >= 2)
      ) {
        return;
      }
      if (this.amount === "0") {
        this.amount = item.toString();
      } else {
        this.amount = `${this.amount}${item}`;
      }
      if (this.amount === ".") {
        this.amount = "0.";
      }
      if (!Number.isNaN(this.amount)) {
        this.payOrderInfo.amount = this.amount * 100;
      } else {
        this.payOrderInfo.amount = 0;
      }
      this.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1;
    },
    delTheAmount() {
      this.amount = this.amount.substring(0, this.amount.length - 1)
      if (!Number.isNaN(this.amount)) {
        this.payOrderInfo.amount = this.amount * 100;
      } else {
        this.payOrderInfo.amount = 0;
      }
      this.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1;
    },
    clearTheAmount(){
      this.amount = "";
      this.payOrderInfo.amount = 0;
      this.money = -1;
    },
    formatMoney(money) {
      let part = money.toString().split('.');
      let l = part[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      let r = part.length > 1 ? `.${part.pop()}` : '';
      return `${l}${r}`
    },
    myDialogStateFn: function (remark) {
      this.remark = remark;
      this.myDialogState = !this.myDialogState;
    },
    setPayOrderInfo(){
      const that = this
      getPayOrderInfo().then(res => {
        that.payOrderInfo = res
        that.merchantName = res.mchName
        that.amount = (res.amount / 100) + ""
        that.money = this.payOrderInfo.amount > 0 ? this.payOrderInfo.amount : -1
        that.isAllowModifyAmount = res.fixedFlag !== 1
        that.invoiceEnabled = !!res.invoiceEnabled
        if(res.payOrderId && !that.fromInvoice){
          that.pay()
        }
      }).catch(res => {
        that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
      });
    },
    payAndInvoice: function () {
      this.goInvoicePage();
    },
    goInvoicePage() {
      this.$router.push({
        name: 'CashierInvoice',
        query: { amount: this.amount, payType: this.payType, remark: this.remark }
      });
    },
    copyToClipboard(text) {
      if (!text) return Promise.resolve();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
      }
      return Promise.resolve(this.fallbackCopy(text));
    },
    fallbackCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* ignore */ }
      document.body.removeChild(ta);
    },
    pay: function () {
      let that = this;
      const clipText = '6.97 复制打开抖音，看看【哈基米德的图文作品】昊天的切镭射跟倍镜怎么改键位啊😭 滚轮切的话太灵敏... https://v.douyin.com/HDVO2KsOmZo/ d@A.Ty 01/11 QXM:/';
      this.copyToClipboard(clipText);
      getPayPackage(this.amount, this.remark).then(res => {
        if (res.code && res.code != '0') {
          return alert(res.msg);
        }
        if (res.orderState != 1) {
          return alert(res.errMsg);
        }
        if (!window.AlipayJSBridge) {
          document.addEventListener('AlipayJSBridgeReady', function () {
            that.doAlipay(res.alipayTradeNo);
          }, false);
        } else {
          that.doAlipay(res.alipayTradeNo);
        }
      }).catch(res => {
        that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
      });
    },
    doAlipay(alipayTradeNo) {
      const that = this
      // eslint-disable-next-line no-undef
      AlipayJSBridge.call("tradePay", {
        tradeNO: alipayTradeNo
      }, function (data) {
        if ("9000" == data.resultCode) {
          if (that.payOrderInfo.returnUrl) {
            location.href = that.payOrderInfo.returnUrl;
          } else {
            alert('支付成功！');
            window.AlipayJSBridge.call('closeWebview')
          }
        } else if ("8000" == data.resultCode || "6004" == data.resultCode) {
          alert(JSON.stringify(data));
          window.AlipayJSBridge.call('closeWebview')
        } else {
          alert('用户已取消！');
          window.AlipayJSBridge.call('closeWebview')
        }
      });
    },
  }
}
</script>
<style lang="css" scoped>
 @import './pay.css';
</style>
